import { ApiRequest } from '../hooks/useApi';

export const customerApiKeysApi = {
  issueApiKey: (): ApiRequest<IssuedCustomerApiKey> => async ({
    httpClient,
    apiSettings,
  }) => {
    const response = await httpClient.post(apiSettings.customerApiKeysUri);

    if (response.hasError) {
      return { error: response.error };
    }

    return { result: response.data };
  },

  getApiKeys: (): ApiRequest<CustomerApiKey[]> => async ({
    httpClient,
    apiSettings,
  }) => {
    const response = await httpClient.get(apiSettings.customerApiKeysUri);

    if (response.hasError) {
      return { error: response.error };
    }

    return { result: response.data };
  },

  revokeApiKey:
    (apiKeyId: number): ApiRequest =>
    async ({ httpClient, apiSettings }) => {
      const response = await httpClient.post(
        apiSettings.revokeCustomerApiKeyUri(apiKeyId),
      );

      if (response.hasError) {
        return { error: response.error };
      }

      return { result: response.data };
    },

  reactivateApiKey:
    (apiKeyId: number): ApiRequest =>
    async ({ httpClient, apiSettings }) => {
      const response = await httpClient.post(
        apiSettings.reactivateCustomerApiKeyUri(apiKeyId),
      );

      if (response.hasError) {
        return { error: response.error };
      }

      return { result: response.data };
    },

  getApiKeyLogs:
    (
      apiKeyId: number,
      page: number,
      pageSize: number,
    ): ApiRequest<CustomerApiRequestLogsPage> =>
    async ({ httpClient, apiSettings }) => {
      const response = await httpClient.get(
        apiSettings.customerApiKeyLogsUri(apiKeyId),
        {
          params: { offset: (page - 1) * pageSize, limit: pageSize },
        },
      );

      if (response.hasError) {
        return { error: response.error };
      }

      return { result: response.data };
    },
};

export interface IssuedCustomerApiKey {
  apiKey: string;
}

export interface CustomerApiKey {
  id: number;
  issuedByUserId: number;
  issuedByUserName: string;
  createdAt: string;
  revokedAt?: string;
}

export interface CustomerApiRequestLogsPage {
  result: CustomerApiRequestLog[];
  offset: number;
  total: number;
}

export interface CustomerApiRequestLog {
  id: number;
  createdAt: string;
  method: string;
  path: string;
  queryString?: string;
  routeValues?: string;
  requestContentType?: string;
  requestBody?: string;
  requestBodyTruncated: boolean;
  statusCode: number;
  responseContentType?: string;
  responseBody?: string;
  responseBodyTruncated: boolean;
  durationMs: number;
  traceIdentifier: string;
}
